import { Aggregator } from './aggregator';

/**
 * This aggregator is used to calculate how long a value stayed the same.
 */
export class Interval<T extends string> extends Aggregator<T> {
  protected intervals: Record<T, number | undefined>;

  protected lastValue: T | undefined;

  protected lastValueAppearedAt: number | undefined;

  constructor(protected defaultIntervals: Record<T, number | undefined>) {
    super();
    this.intervals = { ...defaultIntervals };
  }

  getAggregated(): Record<T, number | undefined> {
    if (this.lastValue && this.lastValueAppearedAt) {
      const now = Date.now();
      this.intervals[this.lastValue] =
        now - this.lastValueAppearedAt + (this.intervals[this.lastValue] || 0);
      this.lastValueAppearedAt = now;
    }

    return { ...this.intervals };
  }

  reset(): void {
    this.intervals = { ...this.defaultIntervals };
    this.lastValue = undefined;
    this.lastValueAppearedAt = undefined;
  }

  protected _add(stat: T): void {
    if (!this.lastValue) {
      this.lastValue = stat;
      this.lastValueAppearedAt = Date.now();

      return;
    }

    if (stat === this.lastValue) {
      return;
    }

    const now = Date.now();
    this.intervals[this.lastValue] =
      now - this.lastValueAppearedAt! + (this.intervals[this.lastValue] || 0);
    this.lastValue = stat as T;
    this.lastValueAppearedAt = now;
  }
}
